import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import referralHeroBackgroundImage from '../../../assets/images/referral-bonus-hero-background.png';
import { BaseButton } from '../../../shared/ui/base-primitives.styles';

type ReferralBonusHeroCardProps = {
  onOpenRaffle?: () => void;
};

const Card = styled(BaseButton).attrs({
  type: 'button',
  'data-ui': 'referral-bonus-hero-card',
})`
  position: relative;
  min-height: ${({ theme }) => theme.scale.px(213)};
  border-radius: ${({ theme }) => theme.scale.px(11)};
  overflow: hidden;
  background: ${({ theme }) => theme.colors.surface.subtle};
  box-sizing: border-box;
  width: 100%;
  text-align: left;
`;

const BackgroundImage = styled.img.attrs({
  alt: '',
  'aria-hidden': true,
})`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: fill;
`;

const Content = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.scale.px(20)};
  right: ${({ theme }) => theme.scale.px(13)};
  bottom: ${({ theme }) => theme.scale.px(22)};
  left: ${({ theme }) => theme.scale.px(13)};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.scale.px(6)};
`;

const BottomCopy = styled.div`
  margin-top: auto;
  display: grid;
  gap: ${({ theme }) => theme.scale.px(4)};
`;

const DrawDate = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.scale.px(12)};
  line-height: ${({ theme }) => theme.scale.px(14)};
`;

const Title = styled.h1`
  margin: 0;
  display: grid;
  font-size: ${({ theme }) => theme.scale.px(24)};
  font-weight: 600;
  line-height: ${({ theme }) => theme.scale.px(28)};
`;

const TitleLineTop = styled.span`
  display: block;
  max-width: ${({ theme }) => theme.scale.px(88)};
`;

const TitleLineBottom = styled.span`
  display: block;
  max-width: ${({ theme }) => theme.scale.px(148)};
`;

const Description = styled.p`
  margin: 0;
  max-width: ${({ theme }) => theme.scale.px(191)};
  font-size: ${({ theme }) => theme.scale.px(12)};
  line-height: ${({ theme }) => theme.scale.px(14)};
`;

export function ReferralBonusHeroCard({
  onOpenRaffle,
}: ReferralBonusHeroCardProps) {
  const { t } = useTranslation();
  const [titleLineTop, titleLineBottom = ''] = t(
    'referralBonus.heroTitle',
  ).split('\n');
  const heroAriaLabel = t('referralBonus.heroTitle').replace('\n', ' ');

  return (
    <Card aria-label={heroAriaLabel} onClick={onOpenRaffle}>
      <BackgroundImage src={referralHeroBackgroundImage} />
      <Content>
        <DrawDate>{t('referralBonus.drawDate')}</DrawDate>
        <BottomCopy>
          <Title>
            <TitleLineTop>{titleLineTop}</TitleLineTop>
            <TitleLineBottom>{titleLineBottom}</TitleLineBottom>
          </Title>
          <Description>{t('referralBonus.heroDescription')}</Description>
        </BottomCopy>
      </Content>
    </Card>
  );
}
